import ModalHeader from './components/ModalHeader';
import ModalFooter from './components/ModalFooter';
import ModalBody from './components/ModalBody';

export { default } from './Modal';
export type { ModalProps } from './Modal';
export { ModalHeader, ModalFooter, ModalBody };
